import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
    wrap: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    stage: {
        position: 'relative',
        width: 'min(100%, 420px)',
        aspectRatio: '1 / 1',
    },
    dashedRing: {
        position: 'absolute',
        inset: '8%',
        borderRadius: '50%',
        border: '1.5px dashed #C9D6E6',
        pointerEvents: 'none',
    },
    centerButton: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: 124,
        height: 124,
        borderRadius: '50%',
        border: 0,
        background: '#ED6628',
        color: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: 14,
        fontWeight: 700,
        boxShadow: '0 16px 40px rgba(237, 102, 40, 0.35)',
        transition: 'transform 200ms cubic-bezier(.32, .72, 0, 1), box-shadow 200ms ease',
        '&:hover': {
            transform: 'translate(-50%, -50%) scale(1.04)',
        },
    },
    centerActive: {
        boxShadow: '0 0 0 8px rgba(237, 102, 40, 0.25), 0 16px 40px rgba(237, 102, 40, 0.35)',
    },
    nodeButton: {
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 6,
        padding: '12px 14px',
        borderRadius: 16,
        fontFamily: 'inherit',
        fontSize: 13,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        boxShadow: '0 8px 24px rgba(23, 41, 57, 0.08)',
        transition: 'transform 200ms ease, opacity 200ms ease',
    },
    govNode: {
        background: '#172939',
        color: '#FFFFFF',
        border: '1px solid #172939',
        cursor: 'pointer',
        '&:hover': {
            transform: 'translate(-50%, -50%) scale(1.04)',
        },
    },
    govActive: {
        boxShadow: '0 0 0 4px rgba(23, 41, 57, 0.25), 0 8px 24px rgba(23, 41, 57, 0.08)',
    },
    inactiveNode: {
        background: '#FFFFFF',
        color: '#1B2430',
        border: '1px solid #E6E9EE',
        opacity: 0.6,
        cursor: 'default',
    },
}));

const PbdqCosEcosystemWheel = ({ activeChild, activeGov, onSelectChild, onSelectGov }) => {
    const classes = useStyles();

    return (
        <div className={classes.wrap}>
            <div className={classes.stage}>
                <div aria-hidden="true" className={classes.dashedRing} />

                {/* Center Node: The Child */}
                <button
                    type="button"
                    onClick={onSelectChild}
                    aria-label="The child — open the COS Children Assessment"
                    className={clsx(classes.centerButton, activeChild && classes.centerActive)}
                >
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                    </svg>
                    The child
                </button>

                {/* Government (active) */}
                <button
                    type="button"
                    onClick={onSelectGov}
                    title="See the COS Government Assessment"
                    style={{ left: '50%', top: '8%' }}
                    className={clsx(classes.nodeButton, classes.govNode, activeGov && classes.govActive)}
                >
                    <span style={{ color: '#8AA3BC', display: 'flex' }}>
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M3 22h18" />
                            <path d="M6 18v-7" />
                            <path d="M10 18v-7" />
                            <path d="M14 18v-7" />
                            <path d="M18 18v-7" />
                            <path d="m12 2 9 5H3z" />
                        </svg>
                    </span>
                    Government
                </button>

                {/* Parents (coming soon) */}
                <button
                    type="button"
                    disabled
                    title="Coming soon"
                    style={{ left: '90%', top: '36%' }}
                    className={clsx(classes.nodeButton, classes.inactiveNode)}
                >
                    <span style={{ color: '#6B7280', display: 'flex' }}>
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                    </span>
                    Parents
                </button>

                {/* Teachers (coming soon) */}
                <button
                    type="button"
                    disabled
                    title="Coming soon"
                    style={{ left: '75%', top: '88%' }}
                    className={clsx(classes.nodeButton, classes.inactiveNode)}
                >
                    <span style={{ color: '#6B7280', display: 'flex' }}>
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
                        </svg>
                    </span>
                    Teachers
                </button>

                {/* School leaders (coming soon) */}
                <button
                    type="button"
                    disabled
                    title="Coming soon"
                    style={{ left: '25%', top: '88%' }}
                    className={clsx(classes.nodeButton, classes.inactiveNode)}
                >
                    <span style={{ color: '#6B7280', display: 'flex' }}>
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M14 22v-4a2 2 0 1 0-4 0v4" />
                            <path d="m18 10 4 2v10H2V12l4-2" />
                            <path d="m4 6 8-4 8 4v16" />
                            <path d="M4 6v16" />
                        </svg>
                    </span>
                    School leaders
                </button>

                {/* Ed-techs (coming soon) */}
                <button
                    type="button"
                    disabled
                    title="Coming soon"
                    style={{ left: '10%', top: '36%' }}
                    className={clsx(classes.nodeButton, classes.inactiveNode)}
                >
                    <span style={{ color: '#6B7280', display: 'flex' }}>
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9" />
                            <path d="M3.6 20h16.8a1 1 0 0 0 .9-1.45L20 16H4l-1.3 2.55a1 1 0 0 0 .9 1.45" />
                        </svg>
                    </span>
                    Ed-techs
                </button>
            </div>
        </div>
    );
};

export default PbdqCosEcosystemWheel;
